import React from 'react';
import PropTypes from 'prop-types';
import { List as ImmutableList } from 'immutable';
import AutoScopeStyles from '../../../Utilities/Decorators/AutoScopeStylesDecorator';
import NavigationMenuItemView from './NavigationMenuItemView.jsx';
import NavigationDropdownMenuItemView from './NavigationDropdownMenuItemView.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../../Utilities/Decorators/ApplyDecorators';

class NavigationMenuView extends React.Component {
    render() {
        const menuItems = this.props.menuItems;
        const menuItemLabels = ImmutableList(menuItems.keys());

           return (
            <ul className="menu">
            {
                menuItemLabels.map((menuItemLabel, index) => {
                    var menuItem = menuItems.get(menuItemLabel);

                    if(ImmutableList.isList(menuItem)) {
                        return (<NavigationDropdownMenuItemView key={ index } label={ menuItemLabel } menuItems={ menuItem } />);
                    } else {
                        return (<NavigationMenuItemView key={ index } label={ menuItemLabel } href={ menuItem } />);
                    }
                })
            }
            </ul>
        );
    }
}

NavigationMenuView.propTypes = {
    menuItems: PropTypes.object.isRequired
};

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(NavigationMenuView);
